if (!customElements.get('plyr-player')) {
  class PlyrPlayer extends HTMLElement {
    constructor() {
      super();
      this.plyrPlayerId = this.querySelector('[data-plyr-player]').id;
      this.autoplay = this.dataset.videoAutoplay === 'true';
      this.controls = this.dataset.videoControls === 'true';
      this.mqlSmall = window.matchMedia('screen and (max-width: 749px)');
      
      if (typeof Plyr !== "undefined")
        this.initializePlayer();
      
    }
  
    initializePlayer() {
      let cfg = {
        fullscreen: {
          enabled: true, 
          fallback: true, 
          iosNative: true, 
          container: null
        }
      };

      if (this.autoplay) {
        Object.assign(cfg, {
          autoplay: true,
          fullscreen: {
            enabled: false,
            fallback: false, 
            iosNative: false, 
            container: null
          },
          loop: {
            active: true  
          },
          muted: true
        });
      };

      if (!this.controls) {
        Object.assign(cfg, {
          controls: []
        });
      };

      if (
        this.mqlSmall.matches &&
        this.hasAttribute('data-video-mobile')
      ) {
        this.querySelector('[data-plyr-player]')
          .setAttribute('data-plyr-embed-id', this.dataset.videoMobile);
      }
      
      const plyrPlayer = new Plyr(`#${this.plyrPlayerId}`, cfg);
      plyrCustomEvents.addEvents(plyrPlayer);
            
    }
  }
  
  customElements.define('plyr-player', PlyrPlayer);
}